import { defineStore } from 'pinia'
import { ref } from 'vue'
import type { Channel } from 'laravel-echo'

import echo from '@/assets/plugin/echo'
import { getNotificationsService, readAllNotificationsService } from '@/services/notification.services'
import { useAuthStore } from '@/stores/authStore'
import type { AppNotification } from '@/model/notification.model'

export const useNotificationStore = defineStore('notification', () => {
    const latest = ref<AppNotification[]>([])
    const unreadCount = ref(0)
    const loading = ref(false)

    let channel: Channel | null = null

    const fetchLatest = async () => {
        loading.value = true

        try {
            const response = await getNotificationsService(1, 10)

            latest.value = response.data.data.data
            unreadCount.value = response.data.unread_count
        } catch {
            // The axios interceptor already reports the failure.
        } finally {
            loading.value = false
        }
    }

    const markAllRead = async () => {
        await readAllNotificationsService()

        unreadCount.value = 0
        latest.value = latest.value.map((item) =>
            item.read_at ? item : { ...item, read_at: new Date().toISOString() },
        )
    }

    const subscribe = () => {
        const userId = useAuthStore().user?.user.id

        if (!echo || channel || !userId) {
            return
        }

        const privateChannel = echo.private(`App.Models.User.${userId}`)

        privateChannel.listen('.notification.created', () => {
            fetchLatest()
        })

        channel = privateChannel
    }

    const unsubscribe = () => {
        const userId = useAuthStore().user?.user.id

        if (!echo || !channel) {
            return
        }

        if (userId) {
            echo.leave(`App.Models.User.${userId}`)
        }

        channel = null
    }

    return { latest, unreadCount, loading, fetchLatest, markAllRead, subscribe, unsubscribe }
})
